import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserModuleApiSuffixModels, encryptedUserIdSelector } from '@app/modules';
import { AppState } from '@app/reducers';
import { AuthenticationModuleApiSuffixModels, IApplicationResponse, ModulesBasedApiSuffix, SidebarDataLoaded, SidebarDataRemoved, emailPattern } from '@app/shared';
import { CrudService, RxjsService, UserService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { Login, Logout } from '../auth.actions';
import { combineLatest } from 'rxjs';
@Component({
  selector: 'app-reset-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.scss']
})

export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  isFormSubmitted = false;
  loginError: boolean = false;
  applicationResponse: IApplicationResponse;
  encryptedUserId = "";

  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService,
    private crudService: CrudService, private store: Store<AppState>, private rxjsService: RxjsService) {
    this.rxjsService.setDialogOpenProperty(true);
  }

  ngOnInit() {
    this.createResetPasswordFormGroup();
    combineLatest([
      this.store.select(encryptedUserIdSelector)
    ]).subscribe((response) => {
      this.encryptedUserId = response[0];
    });
  }

  createResetPasswordFormGroup(): void {
    this.forgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.maxLength(50), Validators.email, emailPattern]]
    })
  }

  onSubmit(): void {
    this.isFormSubmitted = true;
    if (this.forgotForm.invalid) {
      return;
    }
    this.crudService.create(ModulesBasedApiSuffix.AUTHENTICATION, AuthenticationModuleApiSuffixModels.LOGIN, this.forgotForm.value).subscribe((response: IApplicationResponse) => {
      if (typeof response.resources === 'string') {
        const decodedUserData = this.userService.getDecodedLoggedInData(response.resources);
        if (decodedUserData) {
          // remove this hardcode later
          const redirectRouteUrl = "/login";
          const parsedUserData = JSON.parse(decodedUserData['userData']);
          // Fetch the stored regionId from loca storage when refreshtoken is called
          parsedUserData.openScapePabxId = this.userService.openScapePabxId;
          this.store.dispatch(new Login({
            user: parsedUserData, encodedToken: response.resources, encryptedUserId: this.encryptedUserId,
            defaultRedirectRouteUrl: redirectRouteUrl, refreshToken: ''
          }));
          this.crudService.get(
            ModulesBasedApiSuffix.IT_MANAGEMENT,
            UserModuleApiSuffixModels.MODULES_NAVIGATION_FEATURES,
            parsedUserData.roleId,
            false,
            null
          ).subscribe((response: IApplicationResponse) => {
            if (response.isSuccess) {
              const decodedUserAccessPermData = response.resources;
              this.store.dispatch(new SidebarDataLoaded({ response: decodedUserAccessPermData }));
              this.router.navigateByUrl(redirectRouteUrl);
            }
            else {
              this.store.dispatch(new Logout());
              this.store.dispatch(new SidebarDataRemoved());
            }
            this.rxjsService.setGlobalLoaderProperty(false);
          });
        }
        else {
          this.store.dispatch(new Logout());
          this.store.dispatch(new SidebarDataRemoved());
        }
      }
    }, error => {
    })
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
